import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { BrandsPage } from './_dashboard.catalog.brands'

export const Route = createFileRoute('/_dashboard/catalog/brands/$item')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: BrandsItemPage,
})

function BrandsItemPage() {
  const { item } = Route.useParams()
  return <BrandsPage selectedId={item} />
}
